import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ResolveStart} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResetpasswordService } from './../../../services/resetpassword.service';

@Component({
  selector: 'cls-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})

export class HeaderComponent implements OnInit {

  @Input() isEuro: boolean;
  accountid: number;
  username: string;
  password: string;
  submitted = false;
  processing = false;
  loginForm: FormGroup;
  loginerror: string;
  resetForm: FormGroup;
  resetMessage: string;
  resetMessageColour: string;
  home_page = false;
  is_frontend = true;
  dataLoaded  = false;
  constructor(private _router: Router, private http: HttpClient,
    private _formBuilder: FormBuilder, private _resetService: ResetpasswordService) {

    _router.events.subscribe((val) => {
      if (val instanceof ResolveStart) {
        this.home_page = false;
        this.home_page = val.url === '/';
        if (val.url === '/ordering/login') {
          this.is_frontend = false;
        }

        this.detectProject(val.urlAfterRedirects);
        this.dataLoaded = true;
      }
    });
  }

  detectProject(url: string) {
    switch (url) {
      case '/':
      case '/risksolutions':
      case '/data':
      case '/groupservices':
      case '/d-risk':
      case '/news':
      case '/events':
      case '/europe':
      case '/register':
      case '/browser-support':
        this.is_frontend = true;
        break;
      default:
        this.is_frontend = false;
        break;
    }
  }

  ngOnInit() {
    this.loginForm = this._formBuilder.group({
      accountid: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      termsandconditions: ['', Validators.requiredTrue]
    });

    this.resetForm = this._formBuilder.group({
      accountid: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  public onAnchorClick() {
    const header = document.getElementById('header');
    if (header.classList.contains('show')) {
      header.classList.remove('show');
    }
  }
  public onFormSubmit() {
    this.submitted = true;
    this.processing = true;
    if (this.loginForm.invalid) {
      return;
    } else {
      this.redirectToLogin();
    }
  }

  public onResetSubmit() {
    this._resetService.ResetPassword(this.resetForm.controls.email.value, parseInt(this.resetForm.controls.accountid.value, 0))
      .subscribe(next => {
        if ((<any>next).d) {
          // success
          this.updateResetMessage(1);
        } else {
          // fail
          this.updateResetMessage(2);
        }
      }, err => {
        this.updateResetMessage(3);
        if (err && err.networkError && err.networkError.status === 403) {
          this._router.navigate(['/']);
        }
      });
  }

  public updateResetMessage(n: number) {
    switch (n) {
      case 1:
        this.resetMessage = 'Your request has been submitted, please check your email.';
        this.resetMessageColour = 'green';
        break;
      case 2:
        this.resetMessage = 'Something went wrong, please check your details and try again.';
        this.resetMessageColour = 'red';
        break;
      case 3:
        this.resetMessage = 'Error: Service unavailable.';
        this.resetMessageColour = 'red';
        break;
      default:
        this.resetMessage = '';
    }

    setTimeout(() => {
      this.resetMessage = '';
      this.resetMessageColour = '';
    }, 3000);
  }
  // Link called to redirect for login.
  public redirectToLogin() {
    const bl = false;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    };
    const body = JSON.stringify({ account: this.accountid, username: this.username, password: this.password });
    this.http.post(environment.loginUrl, body, httpOptions).subscribe(o => {
      this.processing = false;
      if ((<any>o).d.Ok) {
        window.location.href = environment.orderingUrl;
      } else if ((<any>o).d.RedirectReset) {
        window.location.href = environment.resetUrl + (<any>o).d.ResetKey;
      } else {
        this.loginerror = (<any>o).d.Message;
      }
    });

    setTimeout(() => {
      this.loginerror = '';
    }, 3000);
  }
}
